<template>
  <div class="enterprise-declaration-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <el-tabs type="border-card">
        <el-tab-pane label="园区信息">
          <div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">实际用地面积：</span>
              </div>
              <el-input v-model="formData.coverArea" size="small" style="width: 280px" >
                <template slot="append">亩</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">已建建筑面积：</span>
              </div>
              <el-input v-model="formData.buildArea" size="small" style="width: 280px" >
                <template slot="append">平方米</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">已建公共配套设施建筑面积：</span>
              </div>
              <el-input v-model="formData.pubCmptStrArea" size="small" style="width: 280px" >
                <template slot="append">平方米</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">园区剩余可租面积：</span>
              </div>
              <el-input v-model="formData.rentArea" size="small" style="width: 280px" >
                <template slot="append">平方米</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">园区剩余可售面积：</span>
              </div>
              <el-input v-model="formData.saleArea" size="small" style="width: 280px" >
                <template slot="append">平方米</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">已出售面积：</span>
              </div>
              <el-input v-model="formData.soldArea" size="small" style="width: 280px" >
                <template slot="append">平方米</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">已出租面积：</span>
              </div>
              <el-input v-model="formData.rentedArea" size="small" style="width: 280px" >
                <template slot="append">平方米</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">当前每平方米平均租金：</span>
              </div>
              <el-input v-model="formData.rentAmt" size="small" style="width: 280px" >
                <template slot="append">元/天</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">前每平方米平均售价：</span>
              </div>
              <el-input v-model="formData.sellMetre" size="small" style="width: 280px" >
                <template slot="append">元</template>
              </el-input>
            </div>

            <div class="form-line">
              <div class="textBox">
                <span class="line-text">园区获得各级政府支持的金额：</span>
              </div>
              <el-input v-model="formData.settledEntReceiveGovSupport" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">园区或园内企业获得省级以上荣誉或奖项情况：</span>
              </div>
              <el-input v-model="formData.gardenAwards" size="small" style="width: 280px" />
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">本年度累计安全生产事故数：</span>
              </div>
              <el-input v-model="formData.allSafetyEvent" size="small" style="width: 280px" >
                <template slot="append">件</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">监控设备调用频次：</span>
              </div>
              <el-input v-model="formData.callingFrequency" size="small" style="width: 280px" >
                <template slot="append">件</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">使用时间范围：</span>
              </div>
              <el-select v-model="formData.timeRange" placeholder="请选择" size="mini" style="width: 280px">
                <el-option
                  v-for="item in timeRangeList"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="企业信息">
          <div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">入驻企业总数：</span>
              </div>
              <el-input v-model="formData.companyNumber" size="small" style="width: 280px" >
                <template slot="append">家</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">规模以上企业数：</span>
              </div>
              <el-input v-model="formData.scaleNumber" size="small" style="width: 280px" >
                <template slot="append">家</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">高新技术企业数：</span>
              </div>
              <el-input v-model="formData.techNumber" size="small" style="width: 280px" >
                <template slot="append">家</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">科技型中小企业数：</span>
              </div>
              <el-input v-model="formData.sciNumber" size="small" style="width: 280px" >
                <template slot="append">家</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">隐形冠军企业数：</span>
              </div>
              <el-input v-model="formData.champion" size="small" style="width: 280px" >
                <template slot="append">家</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">精特新"小巨人"企业：</span>
              </div>
              <el-input v-model="formData.specializedAndNewEntNum" size="small" style="width: 280px" >
                <template slot="append">家</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">上市（挂牌）企业数：</span>
              </div>
              <el-input v-model="formData.listNumber" size="small" style="width: 280px" >
                <template slot="append">家</template>
              </el-input>
            </div>

            <div class="form-line">
              <div class="textBox">
                <span class="line-text">入驻企业员工总数：</span>
              </div>
              <el-input v-model="formData.allEmployeeNumber" size="small" style="width: 280px" >
                <template slot="append">人</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中"国千"人才：</span>
              </div>
              <el-input v-model="formData.allGqNumber" size="small" style="width: 280px" >
                <template slot="append">人</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中"省千"人才：</span>
              </div>
              <el-input v-model="formData.allSqNumber" size="small" style="width: 280px" >
                <template slot="append">人</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中正高级工程师人数：</span>
              </div>
              <el-input v-model="formData.allProofengineerNumber" size="small" style="width: 280px" >
                <template slot="append">人</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中高级工程师人数：</span>
              </div>
              <el-input v-model="formData.allSenniorengineerNumber" size="small" style="width: 280px" >
                <template slot="append">人</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中高级技师人数：</span>
              </div>
              <el-input v-model="formData.allSeniortechnicianNumber" size="small" style="width: 280px" >
                <template slot="append">人</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中硕士以上人数：</span>
              </div>
              <el-input v-model="formData.allMasterNumber" size="small" style="width: 280px" >
                <template slot="append">人</template>
              </el-input>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="产值投资">
          <div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">入驻企业税收累计值：</span>
              </div>
              <el-input v-model="formData.allTaxTotal" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">入驻企业营业总收入：</span>
              </div>
              <el-input v-model="formData.allRevenueTotal" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">入驻企业利润总额累计值：</span>
              </div>
              <el-input v-model="formData.allProfitTotal" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">减免入驻企业租金金额：</span>
              </div>
              <el-input v-model="formData.taxReductionTotal" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">专利拥有量：</span>
              </div>
              <el-input v-model="formData.allPatentNumber" size="small" style="width: 280px" >
                <template slot="append">件</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中发明专利：</span>
              </div>
              <el-input v-model="formData.allFmlNumber" size="small" style="width: 280px" >
                <template slot="append">件</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">实用新型专利：</span>
              </div>
              <el-input v-model="formData.utilityModelPatent" size="small" style="width: 280px" >
                <template slot="append">件</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">外观设计专利：</span>
              </div>
              <el-input v-model="formData.industrialDesignPatent" size="small" style="width: 280px" >
                <template slot="append">件</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">已完成投资额：</span>
              </div>
              <el-input v-model="formData.finishedInvestment" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中国有投资额：</span>
              </div>
              <el-input v-model="formData.govInvestment" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中集体投资额：</span>
              </div>
              <el-input v-model="formData.groupInvestment" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中民营投资额：</span>
              </div>
              <el-input v-model="formData.privateInvestment" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中其他投资额：</span>
              </div>
              <el-input v-model="formData.otherInvestment" size="small" style="width: 280px" >
                <template slot="append">万元</template>
              </el-input>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="能耗计量">
          <div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">用电量本期值：</span>
              </div>
              <el-input v-model="formData.electricityData" size="small" style="width: 280px" >
                <template slot="append">千瓦时</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第1个月用电量本期值：</span>
              </div>
              <el-input v-model="formData.currentElectricityFirstMonth" size="small" style="width: 280px" >
                <template slot="append">千瓦时</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第2个月用电量本期值：</span>
              </div>
              <el-input v-model="formData.currentElectricitySecondMonth" size="small" style="width: 280px" >
                <template slot="append">千瓦时</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第3个月用电量本期值：</span>
              </div>
              <el-input v-model="formData.currentElectricityThirdMonth" size="small" style="width: 280px" >
                <template slot="append">千瓦时</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">用水量本期值：</span>
              </div>
              <el-input v-model="formData.waterData" size="small" style="width: 280px" >
                <template slot="append">吨</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第1个月用水量本期值：</span>
              </div>
              <el-input v-model="formData.currentWaterFirstMonth" size="small" style="width: 280px" >
                <template slot="append">吨</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第2个月用水量本期值：</span>
              </div>
              <el-input v-model="formData.currentWaterSecondMonth" size="small" style="width: 280px" >
                <template slot="append">吨</template>
              </el-input>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中第3个月用水量本期值：</span>
              </div>
              <el-input v-model="formData.currentWaterThirdMonth" size="small" style="width: 280px" >
                <template slot="append">吨</template>
              </el-input>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="党群服务">
          <div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中党委：</span>
              </div>
              <el-input v-model="formData.partyCommitteeNum" size="small" style="width: 280px" />
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中党总支：</span>
              </div>
              <el-input v-model="formData.generalPartyBranchNum" size="small" style="width: 280px" />
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中党支部：</span>
              </div>
              <el-input v-model="formData.partyBranchNum" size="small" style="width: 280px" />
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">其中党员人数：</span>
              </div>
              <el-input v-model="formData.partyNumber" size="small" style="width: 280px" />
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">是否有党组织：</span>
              </div>
              <el-select v-model="formData.partyBranch" placeholder="请选择" size="mini" style="width: 280px">
                <el-option
                  v-for="item in partyBranchList"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key">
                </el-option>
              </el-select>
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">服务活动场次：</span>
              </div>
              <el-input v-model="formData.serveActivityCount" size="small" style="width: 280px" />
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">服务企业家次数：</span>
              </div>
              <el-input v-model="formData.serveEntCount" size="small" style="width: 280px" />
            </div>
            <div class="form-line">
              <div class="textBox">
                <span class="line-text">服务人次：</span>
              </div>
              <el-input v-model="formData.servePeopleCount" size="small" style="width: 280px" />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" value="保存" v-if="formData.approveNode === '0' && formData.approveStatus !== '1'"/>
        <button-cancel @cancel="addApproveChain" value="保存并审批" v-if="formData.approveNode === '0' && formData.approveStatus !== '1'"/>
        <button-cancel @cancel="cancel" value="返回" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {getObjectURL} from '../../../utils/toBase64'
import $ from 'jquery'
import {api} from '../../api/PoliticalCommunication'
import {nError, nSuccess} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'
import bus from "../../../utils/bus";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'annual-data-report-manage',
  data () {
    return {
      breadcrumb: [{
        value: '小微政通',
        name: 'quarterly-data-report-manage'
      }, {
        value: '年度数据上报'
      }],
      mainTitle: '年度数据上报',
      subheading: '',

      timeRangeList: [
        {key: '0', label: '工作日'},
        {key: '1', label: '全天'},
      ],
      partyBranchList: [
        {key: '0', label: '否'},
        {key: '1', label: '是'},
      ],

      formData: {
        coverArea: '', // 实际用地面积
        buildArea: '', // 已建建筑面积
        pubCmptStrArea: '', // 已建公共配套设施建筑面积
        rentArea: '', // 园区剩余可租面积
        saleArea: '', // 园区剩余可售面积
        soldArea: '', // 已出售面积
        rentedArea: '', // 已出租面积
        rentAmt: '', // 当前每平方米平均租金
        sellMetre: '', // 前每平方米平均售价
        settledEntReceiveGovSupport: '', // 园区获得各级政府支持的金额
        gardenAwards: '', // 园区或园内企业获得省级以上荣誉或奖项情况
        allSafetyEvent: '', // 本年度累计安全生产事故数
        callingFrequency: '', // 监控设备调用频次
        timeRange: '', // 使用时间范围

        companyNumber: '', // 入驻企业总数
        scaleNumber: '', // 规模以上企业数
        techNumber: '', // 高新技术企业数
        sciNumber: '', // 科技型中小企业数
        champion: '', // 隐形冠军企业数
        specializedAndNewEntNum: '', // 精特新"小巨人"企业
        listNumber: '', // 上市（挂牌）企业数

        allEmployeeNumber: '', // 入驻企业员工总数
        allGqNumber: '', // 其中"国千"人才
        allSqNumber: '', // 其中"省千"人才
        allProofengineerNumber: '', // 其中正高级工程师人数
        allSenniorengineerNumber: '', // 其中高级工程师人数
        allSeniortechnicianNumber: '', // 其中高级技师人数
        allMasterNumber: '', // 其中硕士以上人数

        allTaxTotal: '', // 入驻企业税收累计值
        allRevenueTotal: '', // 入驻企业营业总收入
        allProfitTotal: '', // 入驻企业利润总额累计值
        taxReductionTotal: '', // 减免入驻企业租金金额
        allPatentNumber: '', // 专利拥有量
        allFmlNumber: '', // 其中发明专利
        utilityModelPatent: '', // 实用新型专利
        industrialDesignPatent: '', // 外观设计专利
        finishedInvestment: '', // 已完成投资额
        govInvestment: '', // 其中国有投资额
        groupInvestment: '', // 其中集体投资额
        privateInvestment: '', // 其中民营投资额
        otherInvestment: '', // 其中其他投资额

        electricityData: '', // 用电量本期值
        currentElectricityFirstMonth: '', // 其中第1个月用电量本期值
        currentElectricitySecondMonth: '', // 其中第2个月用电量本期值
        currentElectricityThirdMonth: '', // 其中第3个月用电量本期值
        waterData: '', // 用水量本期值
        currentWaterFirstMonth: '', // 其中第1个月用水量本期值
        currentWaterSecondMonth: '', // 其中第2个月用水量本期值
        currentWaterThirdMonth: '', // 其中第3个月用水量本期值

        partyCommitteeNum: '', // 其中党委
        generalPartyBranchNum: '', // 其中党总支
        partyBranchNum: '', // 其中党支部
        partyNumber: '', // 其中党员人数
        partyBranch: '', // 是否有党组织
        serveActivityCount: '', // 服务活动场次
        serveEntCount: '', // 服务企业家次数
        servePeopleCount: '', // 服务人次
      },
    }
  },
  created() {
    this.getAnnualDataByCode()
  },
  mounted () {},
  methods: {
    // 查询信息
    getAnnualDataByCode () {
      this.$axios.get(`${api.getAnnualDataByCode}/${this.$route.params.id}`, {})
        .then(res => {
          let data = res.data.data
          this.formData = data
        })
        .catch(errorHandler('查询失败'))
    },
    toManagePage () {
      this.$router.push({
        name: 'annual-data-report-manage'
      })
    },

    confirm () {
      this.$axios.post(api.updateAnnualData, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('保存成功')
            this.toManagePage()
          }
        })
        .catch(errorHandler('保存失败'))
    },
    // 提交审批
    addApproveChain () {
      this.$axios.post(api.updateAnnualData, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            this.$axios.post(`${api.addApproveChain}`, {
              uploadDataCode: this.formData.code,
              uploadDataType: '2',
              approveName: this.formData.teskName,
              sponsorAccountCode: bus.global.accountCode,
              sponsorAccountName: bus.global.accountName,
            })
              .then(res => {
                if (res.data.retCode === 1) {
                  nSuccess('操作成功')
                  this.toManagePage()
                }
              })
              .catch(errorHandler('操作失败'))
          }
        })
        .catch(errorHandler('保存失败'))
    },
    cancel () {
      this.toManagePage()
    }
  }
}
</script>

<style scoped>
form {
  width: 100%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
}
.form-title {
  color: #333333;
  font-size: 16px;
  line-height: 24px;
  padding-left: 5px;
  margin-top: 5px;
  border-left: 3px solid #00a0e6;
}
.form-line {
  margin: 10px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.line-text{
  color: #48576a;
  font-size: 14px;
}
.textBox {
  display: inline-block;
  width: 240px;
  min-width: 145px;
  line-height: 32px;
  text-align: right;
}

.form-btn-box {
  margin: 30px auto;
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="less">
.enterprise-declaration-add {
  .form-line-table-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .form-line-table-top-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 12px;
    }
  }
}
.el-switch {
  height: 30px;
}

</style>




// WEBPACK FOOTER //
// src/view/PoliticalCommunication/AnnualDataReport/AnnualDataReportModify.vue